import { useHtzReportShowQuery } from "@/services/backend/htz/report/api/report-api";
import { useParams } from "react-router";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { StructuralAssessmentsTable } from "@/services/backend/htz/report/components/structural-assessments-table";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";

export function StructuralRoute() {
  const { reportId } = useParams();
  const {
    data: report,
    isLoading,
    error,
  } = useHtzReportShowQuery({ id: reportId! });

  if (isLoading) {
    return null;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (!report) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Konstruktive Beurteilung")}</CardTitle>
        <CardDescription>
          {t(
            "Hier werden die einzelnen konstruktiven Beurteilungen für die Bauteile angezeigt.",
          )}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <StructuralAssessmentsTable report={report} />
      </CardContent>
    </Card>
  );
}
